var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSiniestrosInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#8a8a8a;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_22",
    "data-name": "Capa 22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 23,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.33,2.56H5.57a1.36,1.36,0,0,0-1.28.91l-2,5.84v7.81a.87.87,0,0,0,.86.86h2a.87.87,0,0,0,.86-.86V16h10v1.1a.86.86,0,0,0,.86.86h2a.86.86,0,0,0,.85-.86V9.31l-2-5.84A1.36,1.36,0,0,0,16.33,2.56ZM4.75,16.45a.31.31,0,0,1-.31.32H3.76a.31.31,0,0,1-.31-.32V16h1.3Zm13.68,0a.32.32,0,0,1-.32.32h-.67a.32.32,0,0,1-.32-.32V16h1.31Zm0-6.29v4.16a.52.52,0,0,1-.52.52H4a.52.52,0,0,1-.52-.52V10.16A.52.52,0,0,1,4,9.64H17.91A.52.52,0,0,1,18.43,10.16ZM3.93,8.43,5.48,3.79H16.42L18,8.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.94,11.74a.5.5,0,1,1,0,1,.5.5,0,0,1,0-1m0-1a1.51,1.51,0,1,0,1.51,1.51,1.51,1.51,0,0,0-1.51-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16,11.74a.5.5,0,1,1-.5.5.49.49,0,0,1,.5-.5m0-1a1.51,1.51,0,1,0,1.51,1.51A1.5,1.5,0,0,0,16,10.73Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1059",
    "data-name": "Grupo 1059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_1916",
    "data-name": "Trazado 1916"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.38,9.07A1.26,1.26,0,0,1,16.1,8.6a1.25,1.25,0,0,1,.47.47L22,18.54a1.28,1.28,0,0,1-.47,1.73,1.29,1.29,0,0,1-.63.17H10.06A1.26,1.26,0,0,1,8.8,19.17,1.37,1.37,0,0,1,9,18.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22,18.54,16.57,9.07a1.26,1.26,0,0,0-2.19,0L9,18.54a1.27,1.27,0,0,0,1.1,1.9H20.89A1.27,1.27,0,0,0,22,18.54Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "10.06 19.17 10.06 19.17 15.47 9.7 15.48 9.7 20.89 19.17 10.06 19.17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1060",
    "data-name": "Grupo 1060"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_932",
    "data-name": "Rect\\xE1ngulo 932",
    className: "cls-2",
    x: 14.84,
    y: 12.84,
    width: 1.27,
    height: 2.53
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_933",
    "data-name": "Rect\\xE1ngulo 933",
    className: "cls-2",
    x: 14.84,
    y: 16.64,
    width: 1.27,
    height: 1.27
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSiniestrosInactive);
export default __webpack_public_path__ + "static/media/ic-siniestros-inactive.06ab5989846ad9a4dc71d4b5fcd9b81d.svg";
export { ForwardRef as ReactComponent };